import React from "react";
import LegalShell from "./legal/LegalShell";

const Terms = () => (
    <LegalShell title="Terms of Service" effective="20 February 2026">
        <p>
            These Terms of Service (<strong>&ldquo;Terms&rdquo;</strong>) govern your use of
            Coffeein7 (<strong>&ldquo;Coffeein7&rdquo;</strong>, <strong>&ldquo;we&rdquo;</strong>,{" "}
            <strong>&ldquo;our&rdquo;</strong>), a hosted platform operated by{" "}
            <em>[Your registered business name], ABN [XX XXX XXX XXX]</em>, of{" "}
            <em>[registered business address], Australia</em>.
        </p>

        <h2 className="font-display font-black text-2xl mt-8">1. Who these Terms apply to</h2>
        <p>
            These Terms apply to two types of users:
        </p>
        <ul className="list-disc pl-6 space-y-1">
            <li>
                <strong>Café Owners</strong> who sign up to accept orders and run loyalty programs
                through Coffeein7.
            </li>
            <li>
                <strong>Customers</strong> who order coffee, food, or other items from participating cafés.
            </li>
        </ul>

        <h2 className="font-display font-black text-2xl mt-8">2. Café Owner subscription</h2>
        <p>
            When you sign up as a Café Owner, you receive a <strong>3-month free trial</strong>. At the
            end of the trial, monthly billing at the tier you selected begins automatically unless you
            cancel. You may cancel at any time from your admin dashboard — no cancellation fee applies.
        </p>
        <p>
            <strong>14-day money-back guarantee.</strong> If you cancel within 14 days of your first paid
            month, we&rsquo;ll refund that month&rsquo;s subscription fee in full. This applies to the
            first paid month only.
        </p>
        <p>
            <strong>Downgrades &amp; upgrades</strong> take effect at the start of your next billing
            cycle. No pro-rata credits are issued for downgrades.
        </p>

        <h2 className="font-display font-black text-2xl mt-8">3. Customer orders &amp; payments</h2>
        <p>
            Coffeein7 provides the software; your order is a contract between you and the café. Payments
            are processed by <strong>Stripe</strong>. Prices, availability, and pickup times are set by
            each café. If your order is cancelled by the café, you will be refunded via the original
            payment method.
        </p>

        <h2 className="font-display font-black text-2xl mt-8">4. Loyalty stamps &amp; Beans</h2>
        <p>
            Stamps and Beans have no cash value, are non-transferable outside our platform, and may
            expire if inactive for 24 months. Reward catalogue availability is controlled by each café.
        </p>

        <h2 className="font-display font-black text-2xl mt-8">5. Acceptable use</h2>
        <p>
            You agree not to: (a) misuse the service or attempt to access data you don&rsquo;t own,
            (b) enter phone numbers you don&rsquo;t control, (c) use the service to send unsolicited
            marketing, (d) reverse-engineer or resell the platform without written permission.
        </p>

        <h2 className="font-display font-black text-2xl mt-8">6. Availability &amp; support</h2>
        <p>
            We aim for high availability but don&rsquo;t guarantee uninterrupted service. During beta,
            support is provided by email at{" "}
            <a href="mailto:admin@coffeein7.com" className="text-[#FF4F18] hover:underline">
                admin@coffeein7.com
            </a>{" "}
            with best-effort response within 2 business days.
        </p>

        <h2 className="font-display font-black text-2xl mt-8">7. Liability</h2>
        <p>
            To the extent permitted by Australian Consumer Law, Coffeein7&rsquo;s total liability for
            any claim is limited to the fees you have paid in the 12 months preceding the claim. We are
            not liable for indirect or consequential loss.
        </p>

        <h2 className="font-display font-black text-2xl mt-8">8. Governing law</h2>
        <p>
            These Terms are governed by the laws of New South Wales, Australia. Any dispute is subject
            to the exclusive jurisdiction of the courts of New South Wales.
        </p>

        <h2 className="font-display font-black text-2xl mt-8">9. Changes</h2>
        <p>
            We may update these Terms; material changes will be notified by email at least 14 days
            before they take effect.
        </p>

        <p className="text-xs text-[#8C7A72] pt-6">
            This document is a plain-language draft. Please have a lawyer review it before you go public.
        </p>
    </LegalShell>
);

export default Terms;
